var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1373_3752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7561 18.5778L14.782 13.6036C16.1375 11.9458 16.804 9.83038 16.6435 7.69494C16.4831 5.5595 15.508 3.56742 13.92 2.13074C12.3319 0.694065 10.2525 -0.0772832 8.11167 -0.0237567C5.97088 0.0297698 3.93256 0.904076 2.41832 2.41832C0.904076 3.93256 0.0297698 5.97088 -0.0237567 8.11167C-0.0772832 10.2525 0.694065 12.3319 2.13074 13.92C3.56742 15.508 5.5595 16.4831 7.69494 16.6435C9.83038 16.804 11.9458 16.1375 13.6036 14.782L18.5778 19.7561C18.735 19.9079 18.9455 19.9919 19.164 19.99C19.3825 19.9881 19.5915 19.9005 19.746 19.746C19.9005 19.5915 19.9881 19.3825 19.99 19.164C19.9919 18.9455 19.9079 18.735 19.7561 18.5778ZM8.33364 15.0003C7.0151 15.0003 5.72617 14.6093 4.62984 13.8768C3.53351 13.1442 2.67903 12.103 2.17444 10.8849C1.66986 9.66669 1.53784 8.32624 1.79507 7.03304C2.05231 5.73983 2.68724 4.55194 3.61959 3.61959C4.55194 2.68724 5.73983 2.05231 7.03304 1.79507C8.32624 1.53784 9.66669 1.66986 10.8849 2.17444C12.103 2.67903 13.1442 3.53351 13.8768 4.62984C14.6093 5.72617 15.0003 7.0151 15.0003 8.33364C14.9983 10.1011 14.2953 11.7957 13.0455 13.0455C11.7957 14.2953 10.1011 14.9983 8.33364 15.0003Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1373_3752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/searchicon.44fa773bb6f1e0d9656bffe87b5b3663.svg";
export { ForwardRef as ReactComponent };